export default __webpack_public_path__ + "static/media/about-8.828a0e75.png";